module.exports = __webpack_public_path__ + "static/media/S23-0167_2.99_Mama_Burger_Website_Mobile_767x845.3331f502.jpg";